module.exports = __webpack_public_path__ + "static/media/logo.11772edc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 96
// module chunks = 0